import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'monthNameShortPipe',
})
export class MonthNameShortPipe implements PipeTransform {
  transform(value: Date): string {
    if (value === null) {
      return null;
    }
    return format(parseISO(value.toString()), 'LLLL', { locale: de })
      .substring(0, 3)
      .toUpperCase();
  }
}
